import React from 'react';

import { useTheme } from 'styled-components/native';
import { Linking, Platform, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import desktopBackground from '../../assets/images/psychologicalAssistance/desktop.png';
import mobileBackground from '../../assets/images/psychologicalAssistance/mobile.png';
import { PageWithCard } from '~/components/@hello-ui/PageWithCard';
import { Button, Collapse, MobileAutoSpace, Typography } from '~/components/@hello-ui';
import { CallIcon } from '~/components/Icons/Call';
import { PsychologicalAssistanceIcon } from '~/components/Icons/PsychologicalAssistanceIcon';
import { PageWithCardVariant } from '~/components/@hello-ui/PageWithCard/enums/PageWithCardVariant';

export const PsychologicalAssistance = (): JSX.Element => {
  const theme = useTheme();
  const navigation = useNavigation();
  const backgroundImage = Platform.OS === 'web' ? desktopBackground : mobileBackground;

  return (
    <PageWithCard
      variant={PageWithCardVariant.FeaturedImage}
      featuredImageOptions={{
        backgroundImage,
        title: 'Orientação Psicológica',
        titleStartContent: <PsychologicalAssistanceIcon />,
        onBack: () => navigation.navigate('BenefitsWellBeing'),
      }}>
      <View>
        <Typography variant="body2">
          <Typography variant="bodyHighlight2">Disponível por telefone</Typography>, de forma rápida
          e acessível para todos. Após o primeiro atendimento, caso necessário, você pode ser{' '}
          <Typography variant="bodyHighlight2">encaminhado para atendimento presencial</Typography>{' '}
          sem custo.
        </Typography>
      </View>
      <View className="pt-24">
        <Collapse title="Saiba mais">
          <Typography variant="body2" className="mb-8">
            Ao acionar o serviço, responda um breve questionário por e-mail ou WhatsApp para receber
            as <Typography variant="bodyHighlight2">orientações mais adequadas</Typography> para seu
            cenário:
          </Typography>
          <Typography variant="body2" className="mb-8 ml-8">
            • Entenda o que pode ter desencadeado seu mal-estar;
          </Typography>
          <Typography variant="body2" className="mb-8 ml-8">
            • Identifique padrões comportamentais;
          </Typography>
          <Typography variant="body2" className="mb-8 ml-8">
            • Investigue fatores emocionais;
          </Typography>
          <Typography variant="body2" className="mb-8 ml-8">
            • Identifique fatores familiares de risco;
          </Typography>
          <Typography variant="body2" className="mb-8 ml-8">
            • Receba orientações sobre como cuidar da sua saúde mental.
          </Typography>
          <Typography variant="body2" className="mb-8">
            Serviço disponível de segunda à sexta, das 9 às 18 horas.
          </Typography>
          <Typography variant="body2">
            <Typography variant="bodyHighlight2">IMPORTANTE:</Typography> Você tem acesso a 3
            atendimentos durante a vigência de plano.
          </Typography>
        </Collapse>
      </View>

      <MobileAutoSpace />
      <View className="mb-24 mt-40 w-full items-center self-center text-center mobile:mb-16 mobile:mt-24">
        <Typography variant="bodyHighlight2">Para utilizar o benefício, é só ligar</Typography>
        <Typography variant="bodyHighlight2">e solicitar a Orientação Psicológica:</Typography>
      </View>

      {theme.isMobile ? (
        <Button
          icon={<CallIcon color={theme.colors.background} />}
          iconPosition="left"
          variant="primary"
          onPress={() => Linking.openURL('tel:08007029897')}>
          Ligar
        </Button>
      ) : (
        <View className="h-[106px] w-full items-center justify-center self-center rounded-lg bg-background-gray text-center">
          <View className="mb-4 flex-row items-center space-x-2">
            <CallIcon color={theme.colors['black-title']} />
            <Typography variant="body2">Telefone:</Typography>
          </View>
          <Typography variant="subtitle">0800 702 9897</Typography>
        </View>
      )}
    </PageWithCard>
  );
};
